import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { LocalStorageService } from "ngx-webstorage";
import { secret } from "app/app.env";
import { PainelService } from "app/shared/services/painel.service";

@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
})
export class ChatComponent implements OnInit, OnDestroy {
  public scriptEle = document.createElement("script");
  private isChat: boolean;
  public dataUser: any;
  public dataWhatsapp: any;
  public whatsappButton = true;

  constructor(
    private localStorage: LocalStorageService,
    private painelService: PainelService,
    private localSt: LocalStorageService
  ) {
    this.scriptEle.id = "chat";
  }

  ngOnInit() {
    this.painelService
      .chatParameters(this.localStorage.retrieve(secret.userData).codeCobra)
      .subscribe(
        (result: any) => {
          if (result !== undefined) {
            this.isChat = true;
            this.dataUser = result;
            this.dataWhatsapp = result.whatsApp;
            this.setDados(result);
          } else {
            this.isChat = false;

            throw "Atende diz: não encontrei os dados do chat.. :(";
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }

  whatsapp() {
    let params = this.localSt.retrieve(secret.parameters);
    const { whatsApp } = params;

    // console.warn("Dados do whatsApp");
    // console.warn(params);

    try {
      if (whatsApp) {
        if (whatsApp.number) {
          let ddi = whatsApp.ddi || 55;
          let ddd = whatsApp.ddd;
          let number = whatsApp.number;
          let text = whatsApp.initialMessage || "";
          return `https://api.whatsapp.com/send?phone=${ddi}${ddd}${number}&text=${text}`;
        } else {
          this.whatsappButton = false;
        }
      } else {
        this.whatsappButton = false;
      }
    } catch (error) {
      console.error(error.message);
      this.whatsappButton = false;
    }
  }

  setDados(dados) {
    const user: any = {};
    user.description = {};

    const { contract, chat, contacts } = dados;

    if (contract && chat) {
      let codcobra = contract.codeCobra || "";
      var idLista = "";
      let idUserCompany = "";
      let keyUserCompany = "";

      if (chat.integration) {
        if (chat.integration.serviceContracted) {
          if (chat.integration.serviceContracted.userCompany) {
            idUserCompany =
              chat.integration.serviceContracted.userCompany.id || "";
            keyUserCompany =
              chat.integration.serviceContracted.userCompany.key || "";
          }
        }
      }

      if (chat.parameter) {
        idLista = chat.parameter.id || "";
      }

      let json = {
        codcobra,
        idUserCompany,
        idLista,
        keyUserCompany,
      }; // nothin

      user["description"] = JSON.stringify(json);
      user.name = contract.debtor.name ? contract.debtor.name : "";
      user.email = contacts.email.email ? contacts.email.email : "";
      user.phone = `+55 (${contacts.phone.ddd ? contacts.phone.ddd : "--"}) ${
        contacts.phone.number ? contacts.phone.number : "--"
      }`;

      if (chat.integration) {
        let serviceContracted = chat.integration.serviceContracted; //
        if (serviceContracted) {
          let integration = serviceContracted.integration;
          if (integration) {
            if (integration.partner.id == 8) {
              if (chat.parameter) {
                this.jivo(user, chat.parameter.idPartnerExternal);
              } else {
                console.warn(
                  "chat.parameter.idPartnerExternal Não implementado"
                );
              }
            } else {
              console.warn("Chat Não implementado");
            }
          } else {
            console.warn("Parceiro não encontrado");
          }
        } else {
          console.warn("Nenhum serviço de chat contratado");
        }
      }
    }
  }

  jivo(contactInfo, widget_id) {
    this.scriptEle.type = "text/javascript";
    this.scriptEle.async = true;
    this.scriptEle.src = `//code.jivosite.com/script/widget/${widget_id}`; // script jivochat

    const functions = document.createElement("script");
    functions.innerHTML = `
      function jivo_onLoadCallback() {
        jivo_api.setContactInfo(${JSON.stringify(contactInfo)});
      }`;

    const allScript = document.getElementsByTagName("script")[0];

    allScript.parentNode.insertBefore(this.scriptEle, allScript);
    allScript.parentNode.insertBefore(functions, allScript);
  }

  ngOnDestroy() {
    if (this.isChat) {
      const chat_widget = document.getElementById(this.scriptEle.id);
      chat_widget.parentNode.removeChild(chat_widget);
      let key: string;
      for (let i = 0; i < localStorage.length; i++) {
        key = localStorage.key(i);
        if (key.match(/jv.*/)) {
          window.localStorage.removeItem(key);
        }
      }
      window.location.reload();
    }
  }
}
